import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgModel } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';
import { DialogBase } from 't4core';
import { TimePickerComponent } from 't4core';
import { T4DataService } from 't4core';
//import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
    selector: 'createScheduledReportDialog',
    templateUrl: './createScheduledReportDialog.html',
    styleUrls: ['./createScheduledReportDialog.css']
})
export class createScheduledReportDialog extends DialogBase implements OnInit {

    form: FormGroup;
    description: string;
    @ViewChild("txtPickupDate", {static: false}) public txtPickupDate: NgModel;
    @ViewChild("txtPickupTime", {static: false}) public txtPickupTime: TimePickerComponent;
    public interval = "3";
    public dateToday:moment.Moment = moment();
  public fromDate: moment.Moment = moment();
  public toDate: moment.Moment = moment();
    public runTime = "23";
    public reportDatabase: string;
    public reportName: string;
  public savedReport: Boolean;

  public dayOfWeek: string = "1";
  public method: string = "0";
  public format: string = "0";

  public email: string;
  public webhook: string;

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<createScheduledReportDialog>,
      @Inject(MAT_DIALOG_DATA) public params: any,
      private dataSvc: T4DataService
    ) {
        super("createScheduledReportDialog");
        this.reportDatabase = params.reportDatabase; 
        this.reportName = params.reportId;
    }

    ngOnInit() {
    }


    async save() {
        var token = this.beginLoad("Turbo.Service.CreateScheduledReport.ldrSaving", "Creating scheduled report", null);
        var id = await this.dataSvc.ScheduleReport(this.reportName, this.email, this.webhook, this.fromDate, this.toDate, this.format, this.interval, this.dayOfWeek);
        if (id) {
            this.endLoad(token);
            this.UI.snackBar(this.translate("Turbo.Service.CreateScheduledReport.ReportConfirmed.Headlinee", "The scheduled report has been saved."));
            this.close();
        }
        else {
            this.endLoad(token);
            this.UI.alert("Turbo.Service.CreateScheduledReport.ReportFailed.Headline", "Failed!", "Turbo.Service.CreateScheduledReport.ReportFailed.Headline.Message", "The scheduled report could not be saved.");
        }
    }

    close() {
        this.dialogRef.close();
    }
}
